import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import DashboardListCard from 'modules/common/dashboard/DashboardListCard';
import BplsDashboardChartContainerE2E from './containers/BplsDashboardChartContainerE2E';
import DashboardMapContainer from './containers/DashboardMapContainer';
import * as actions from './action';
import * as c from './constant';

function TransactionsContainer({ totalStats, getTotalStatsE2E, getMapDataE2E, mapData }) {

  const returnNewTransactionData = () => {
    const data = _.get(totalStats, 'item.total_bpls_new_per_status');
    return {
      label: 'New',
      total: _.get(totalStats, 'item.total_bpls_new', 0),
      // photo: ''
      list: [
        {
          label: 'For Checking',
          value: _.get(data, 'FOR CHECKING', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'For Resubmission',
          value: _.get(data, 'FOR RESUBMISSION', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Cancelled',
          value: _.get(data, 'CANCELLED', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Expired Reference Number',
          value: _.get(data, 'EXPIRED REFERENCE NUMBER', 0),
          borderClassName: 'rejected',
        },

        {
          label: 'For Delivery',
          value: _.get(data, 'FOR DELIVERY', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Received',
          value: _.get(data, 'RECEIVED', 0),
          borderClassName: 'paid',
        },
      ],
    };
  };

  const returnRenewTransactionData = () => {
    const data = _.get(totalStats, 'item.total_bpls_renewal_per_status');
    return {
      label: 'Renewal',
      total: _.get(totalStats, 'item.total_bpls_renewal', 0),
      // photo: ''
      list: [
        {
          label: 'For Checking',
          value: _.get(data, 'FOR CHECKING', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Pending',
          value: _.get(data, 'PENDING', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'For Resubmission',
          value: _.get(data, 'FOR RESUBMISSION', 0),
          borderClassName: 'rejected',
        },
        {
          label: 'Cancelled',
          value: _.get(data, 'CANCELLED', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Expired Reference Number',
          value: _.get(data, 'EXPIRED REFERENCE NUMBER', 0),
          borderClassName: 'waiting',
        },

        {
          label: 'For Delivery',
          value: _.get(data, 'FOR DELIVERY', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Received',
          value: _.get(data, 'RECEIVED', 0),
          borderClassName: 'paid',
        },
      ],
    };
  };

  const returnQuarterlyTransactionData = () => {
    const data = _.get(totalStats, 'item.total_bpls_quarterly_per_status');
    return {
      label: 'Quarterly',
      total: _.get(totalStats, 'item.total_bpls_quarterly', 0),
      // photo: ''
      list: [
        {
          label: 'Pending',
          value: _.get(data, 'FOR CHECKING', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Cancelled',
          value: _.get(data, 'CANCELLED', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Expired Reference Number',
          value: _.get(data, 'EXPIRED REFERENCE NUMBER', 0),
          borderClassName: 'waiting',
        },

        {
          label: 'For Delivery',
          value: _.get(data, 'FOR DELIVERY', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Paid',
          value: _.get(data, 'PAID', 0),
          borderClassName: 'paid',
        },
      ],
    };
  };

  const returnDelinquentTransactionData = () => {
    const data = _.get(totalStats, 'item.total_bpls_delinquent_per_status');
    return {
      label: 'Delinquent',
      total: _.get(totalStats, 'item.total_bpls_delinquent', 0),
      // photo: ''
      list: [
        {
          label: 'For Checking',
          value: _.get(data, 'FOR CHECKING', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'For Resubmission',
          value: _.get(data, 'FOR RESUBMISSION', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Cancelled',
          value: _.get(data, 'CANCELLED', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Expired Reference Number',
          value: _.get(data, 'EXPIRED REFERENCE NUMBER', 0),
          borderClassName: 'rejected',
        },
      ],
    };
  };

  const returnChangeTransactionData = () => {
    const data = _.get(totalStats, 'item.total_bpls_change_per_status');
    return {
      label: 'Change',
      total: _.get(totalStats, 'item.total_bpls_change', 0),
      // photo: ''
      list: [
        {
          label: 'For Checking',
          value: _.get(data, 'FOR CHECKING', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'For Resubmission',
          value: _.get(data, 'FOR RESUBMISSION', 0),
          borderClassName: 'rejected',
        },
        {
          label: 'Cancelled',
          value: _.get(data, 'CANCELLED', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Expired Reference Number',
          value: _.get(data, 'EXPIRED REFERENCE NUMBER', 0),
          borderClassName: 'waiting',
        },

        {
          label: 'For Delivery',
          value: _.get(data, 'FOR DELIVERY', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Received',
          value: _.get(data, 'RECEIVED', 0),
          borderClassName: 'paid',
        },
      ],
    };
  };

  const returnRetirementTransactionData = () => {
    const data = _.get(totalStats, 'item.total_bpls_change_per_status');
    return {
      label: 'Retirement',
      total: _.get(totalStats, 'item.total_bpls_change', 0),
      // photo: ''
      list: [
        {
          label: 'For Checking',
          value: _.get(data, 'FOR CHECKING', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'For Resubmission',
          value: _.get(data, 'FOR RESUBMISSION', 0),
          borderClassName: 'rejected',
        },
        {
          label: 'Cancelled',
          value: _.get(data, 'CANCELLED', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Expired Reference Number',
          value: _.get(data, 'EXPIRED REFERENCE NUMBER', 0),
          borderClassName: 'waiting',
        },
        {
          label: 'Paid',
          value: _.get(data, 'PAID', 0),
          borderClassName: 'paid',
        },
      ],
    };
  };

  useEffect(() => {
    getTotalStatsE2E();
    getMapDataE2E()
  }, []);

  return (
    <div className="container-fluid mb-3 pt-4">
      <div className="row">
        <div className="col-4 pl-0">
          <DashboardListCard data={returnNewTransactionData()} className="mb-3" />
          <DashboardListCard data={returnRenewTransactionData()} className="mb-3" />
          <DashboardListCard data={returnQuarterlyTransactionData()} className="mb-3" />
          <DashboardListCard data={returnDelinquentTransactionData()} className="mb-3" />
          <DashboardListCard data={returnChangeTransactionData()} className="mb-3" />
          <DashboardListCard data={returnRetirementTransactionData()} className="mb-3" />
        </div>
        <div className="col-8 pr-0">
          {/* todo:  create and replace this with BplsDashboardChartContainerE2EE2E for e2e dashboard component */}
          <BplsDashboardChartContainerE2E />
          <DashboardMapContainer data={mapData} />
        </div>
      </div>
    </div>
  );
}

TransactionsContainer.propTypes = {
  totalStats: PropTypes.instanceOf(Object).isRequired,
  getTotalStatsE2E: PropTypes.instanceOf(Function).isRequired,
  getMapDataE2E: PropTypes.instanceOf(Function).isRequired,
  mapData: PropTypes.instanceOf(Array).isRequired,
};

const mapStateToProps = ({ api }) => ({
  totalStats: _.get(api, `${c.GET_TOTAL_STATS_E2E}`) || {},
  mapData: _.get(api, `${c.GET_MAP_DATA_E2E}.list`) || [],
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(TransactionsContainer);
